<template>
  <div id="app" :class="['app', { 'logged-in': user.isAuthenticated, 'is-admin': user.isAdmin, 'rd-app': isNewDesign }]">

    <template v-if="!isNewDesign">
      <navigation></navigation>
      <transition name="fade">
      <router-view/>
      </transition>
      <b-container class="logo-footer">
        <b-row class="logo-row">
          <b-col class="text-center pull-right">
            <img src="./assets/RSKlogo-rgb.svg" alt="Region Skåne logotyp" class="logo" width="100">
          </b-col>
        </b-row>
        <div v-if="cookieText" class="cookie-warning">
          <p>{{cookieText}}</p>
        </div>
      </b-container>
      <div class="d-flex justify-content-center">
        <back-to-top bottom="20px" right="unset" class="margin-fix">
            <mu-float-button icon="keyboard_arrow_up" class="backtotop-button"/>
        </back-to-top>
      </div>
    </template>
    
    <template v-else>
      <navigation></navigation>
      
      <transition name="fade">
        <router-view/>
      </transition>
      
      <footer class="rd-footer">
        <img src="./assets/RSKlogo-rgb.svg" alt="Region Skåne logotyp" class="logo" width="80">

        <p v-if="cookieText">{{cookieText}}</p>
      </footer>

      <div class="d-flex justify-content-center">
        <back-to-top bottom="20px" right="unset" class="margin-fix">
            <mu-float-button icon="keyboard_arrow_up" class="backtotop-button"/>
        </back-to-top>
      </div>
    </template>
  </div>
</template> 

<script>
import { clearAll } from './store/actions'
import { isContainerApp } from './services/helpers'

export default {
  name: 'app',
  beforeMount () {
    clearAll(this.$store)
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isMobile () {
      return isContainerApp()
    },
    cookieText () {
      if (this.$route.name === 'Logga in') {
        return 'Webbplatsen använder sig av cookies för att hantera inloggningen.'
      }
      return ''
    },
    isNewDesign () {
      return this.$route.name === 'EditeraKrossningsPost'
    }
  }
}

var b = document.documentElement
b.setAttribute('data-useragent', navigator.userAgent)
b.setAttribute('data-platform', navigator.platform)
b.className += ((!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) ? ' touch' : '')
</script>

<style scoped lang="scss">
.backtotop-button{
  background-color: $orange;
}
.margin-fix{
  margin-left:-30px;
}
</style>

<style lang="scss">
@import './styles/base.scss';
@import './styles/rd-style.scss';

.logo-footer {
  margin-top: auto;
}

.cookie-warning {
  text-align: center;
  padding: 1rem 2rem;
}
.footer-image{
  text-align:right;
  min-height: 50px;
}
.footer-img-crop {
  display: inline-block;
  height: 180px;
  width: 50%;
  overflow: hidden; 
}
.footer-img-crop {
  margin-top: 40px;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
.app{
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  max-width: 768px;
  margin: 0 auto;
  background-color: #fff;
  @media (min-width: 769px) {
    -moz-box-shadow: 0px 10px 12px 0px #ccc,
                      0px -10px 12px 0px #ccc;
    -webkit-box-shadow: 0px 10px 12px 0px #ccc,
                        0px -10px 12px 0px #ccc;
    box-shadow: 0px 10px 12px 0px #ccc,
                0px -10px 12px 0px #ccc;
  }
}
body{
  @media (min-width: 769px) {
  background-color:#fbfbfb;
  }
}
.logo-row{
  padding-bottom: 1rem;
}
</style>
